import React, { useState, useEffect } from "react";
import { Steps } from "antd";
import { classNames } from "@react-pdf-viewer/core";

const { Step } = Steps;

//!Upload progress is currently only for the documents
//current=2 is the document component will add enum to differentiate

export const ProgressControl = ({
  demogrPogress,
  qualifProgress,
  docsProgress,
  uploadProgress,
  className,
  NumDocs = 5,
}) => {
  const [message, setMessage] = useState(0);

  useEffect(() => {
    checkUploadProgress();
  }, [uploadProgress]);

  const checkUploadProgress = () => {
    if (uploadProgress == 20) setMessage(1);
    else if (uploadProgress == 40) setMessage(2);
    else if (uploadProgress == 60) setMessage(3);
    else if (uploadProgress == 80) setMessage(4);
    else if (uploadProgress == 100) setMessage(5);
    // if (uploadProgress==20) setMessage(1)
    // else if (uploadProgress==40) setMessage(2)
    // else if (uploadProgress==60) setMessage(3)
    // else if (uploadProgress==80) setMessage(4)
    // else if (uploadProgress==100) setMessage(5)
    else setMessage(0);
  };

  const items = [
    {
      id: "pers",
      status: { demogrPogress },
      title: "Personal Information",
      description: "",
    },
    {
      id: "qua",
      status: { qualifProgress },
      title: "Qualifications",
      description: "",
    },
    {
      id: "doc",
      status: { docsProgress },
      title: "Documents",
      description: `${message} of ${NumDocs} uploaded`,
    },
  ];

  return (
    <div className={className}>
      <Steps current={2} percent={uploadProgress} responsive={true}>
        <Step
          status={demogrPogress}
          title="Personal Information"
          description=""
        />
        <Step status={qualifProgress} title="Qualifications" description="" />
        <Step
          status={docsProgress}
          title="Documents"
          description={`${message} of ${NumDocs} uploaded`}
        />
      </Steps>
    </div>
  );
};

// export default ProgressControl
